import { type ModuleData, ModuleProvider, useModule } from '#providers'

export type SamsungBrowserWarningModuleData = ModuleData<{}, void, void>

export const SamsungBrowserWarningModuleProvider: typeof ModuleProvider<SamsungBrowserWarningModuleData> =
	ModuleProvider
export const useSamsungBrowserWarningModule: typeof useModule<SamsungBrowserWarningModuleData> =
	useModule
